import { LuCalendarRange } from 'react-icons/lu';
import { MdOutlineLibraryBooks } from 'react-icons/md';

export const MENU_LIST = [
  {
    label: 'Agendas',
    path: 'agendas',
    icon: <MdOutlineLibraryBooks size={24} />
  },
  {
    label: 'Calendário',
    path: 'calendario',
    icon: <LuCalendarRange size={24} />
  },
];
